import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mrp-report", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/mrp-report/csv", { params });
};

const mrpReportService = {
  getAll,
  getAllForCSV
};

export default mrpReportService;